import { SelectItem } from 'vet-bones/utils/select';

import { RelationshipDirection } from 'src/containers/ProjectDiagram/constants/modelConcept';

export enum ClassDrawerTab {
  BASIC = 'basic',
  HIERARCHY = 'hierarchy',
  RELATIONSHIPS = 'relationships',
  ATTRIBUTES = 'attributes',
  GEOSPATIAL = 'geospatial',
}

export type ClassRelationshipItem = SelectItem & {
  directions: RelationshipDirection[];
  highlighted?: boolean;
};
